import { all, takeLatest } from '@redux-saga/core/effects'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import {
  ApiAccountApprovalEvent,
  ApiAccountApprovalState,
  UserInformation
} from '@/api/_legacy/generated-api'
import { createLogoutExtraReducers } from '@/utilities/redux'

import { Errors } from '../../../../tradebuilder-v2/util'

export type ApprovalStateWithUsers = {
  approvalState: ApiAccountApprovalState
  usersInformation: UserInformation[]
}

export type SubmitStepState = {
  approvalEvents: ApiAccountApprovalEvent[]
  canProceed: boolean
  errors: Errors
  generalErrors?: []
}

const initialState: SubmitStepState = {
  canProceed: true,
  errors: {},
  generalErrors: [],
  approvalEvents: []
}

export const submitSlice = createSlice({
  name: 'submitStep',
  initialState,
  reducers: {
    reset: state => {
      state.canProceed = true
    },
    setInvalid: (state, action: PayloadAction<Errors>) => {
      state.errors = action.payload
    },
    setEvents: (state, action: PayloadAction<ApiAccountApprovalEvent[]>) => {
      state.approvalEvents = action.payload
        ? action.payload.filter(x => x.statusBefore === 'Draft' || x.statusAfter === 'Rejected')
        : []
    },
    requestMoveNext: () => {
      // dummy comment to keep linter happy
    },
    moveNext: () => {
      // dummy comment to keep linter happy
    },
    moveBack: () => {
      // dummy comment to keep linter happy
    }
  },
  extraReducers: builder => {
    const logoutReducers = createLogoutExtraReducers(initialState)
    Object.entries(logoutReducers).forEach(([actionType, reducer]) => {
      builder.addCase(actionType as any, reducer)
    })
  }
})

function* requestMoveNextSaga() {
  //
}

export function* termsRootSaga() {
  yield all([takeLatest('submitStep/requestMoveNext', requestMoveNextSaga)])
}

export const actions = { ...submitSlice.actions }

export type TradeSubmitActions = typeof actions

export default submitSlice.reducer
